export default __webpack_public_path__ + "static/media/icon-algostudy-n@3x.241ce2e0.webp";